import { useMemo } from 'react';
import Cookies, { CookieSetOptions } from 'universal-cookie/es6';

import { CookiesKeys } from '../enums/cookies-keys.enum';

interface IUseCookies {
  setCookie: (key: CookiesKeys, value: any, expires?: Date) => void;
  removeCookie: (key: CookiesKeys) => void;
  getCookie: <T = string>(key: CookiesKeys) => T;
}

export const useCookies = (): IUseCookies => {
  const cookies = useMemo(() => new Cookies(), []);

  const setCookie = useMemo(
    () => (key: CookiesKeys, value: any, expires?: Date) => {
      const options: CookieSetOptions = { path: '/' };

      if (expires) {
        options.expires = expires;
      }

      cookies.set(key, value, options);
    },
    [cookies]
  );

  const removeCookie = useMemo(
    () => (key: CookiesKeys) => {
      cookies.remove(key, { path: '/' });
    },
    [cookies]
  );

  const getCookie = useMemo(
    () => (key: CookiesKeys): any => {
      return cookies.get(key);
    },
    [cookies]
  );

  return {
    setCookie,
    removeCookie,
    getCookie,
  };
};
